import { Money } from "./money";

export class MoneyFactory {
  constructor(
    private readonly currencyCode: string,
    private readonly locale?: string,
  ) {}

  create(amount: number): Money {
    return new Money(amount, this.currencyCode, this.locale);
  }

  zero(): Money {
    return Money.zero(this.currencyCode);
  }

  getCurrencyCode(): string {
    return this.currencyCode;
  }

  getCurrencySymbol(): string | undefined {
    return Money.getCurrencyInfo(this.currencyCode).symbol;
  }
}
